<script lang="ts">
    import Fa from 'svelte-fa'
    import { faChevronDown, faChevronUp, faPlus, faXmark } from '@fortawesome/free-solid-svg-icons'
    import type { DynamicTableColumn, DynamicTableColumnType } from '../types/dynamic-table'
    import { createDefaultDynamicTableData } from '../types/dynamic-table'

    export let data: Record<string, any>

    if (!data.columns) Object.assign(data, createDefaultDynamicTableData())

    const COLUMN_TYPES: { value: DynamicTableColumnType; label: string }[] = [
        { value: 'text', label: 'Texto' },
        { value: 'number', label: 'Número' },
        { value: 'date', label: 'Data (automática)' },
        { value: 'time', label: 'Hora (automática)' },
        { value: 'signature', label: 'Assinatura' },
        { value: 'row_number', label: 'Numeração (automática)' },
    ]

    function addColumn() {
        const column: DynamicTableColumn = {
            id: crypto.randomUUID(),
            label: `Coluna ${data.columns.length + 1}`,
            type: 'text',
        }
        data.columns = [...data.columns, column]
    }

    function removeColumn(index: number) {
        data.columns = data.columns.filter((_: DynamicTableColumn, i: number) => i !== index)
    }

    function moveColumn(index: number, direction: -1 | 1) {
        const newIndex = index + direction
        if (newIndex < 0 || newIndex >= data.columns.length) return
        const updated = [...data.columns]
        const [moved] = updated.splice(index, 1)
        updated.splice(newIndex, 0, moved)
        data.columns = updated
    }
</script>

<div class="block-preview">
    {#each data.columns as column, index (column.id)}
        <div class="column-row">
            <div class="column-reorder">
                <button type="button" class="reorder-btn" on:click={() => moveColumn(index, -1)} disabled={index === 0} title="Mover para cima">
                    <Fa icon={faChevronUp} size="xs" />
                </button>
                <button
                    type="button"
                    class="reorder-btn"
                    on:click={() => moveColumn(index, 1)}
                    disabled={index === data.columns.length - 1}
                    title="Mover para baixo"
                >
                    <Fa icon={faChevronDown} size="xs" />
                </button>
            </div>
            <input type="text" class="column-label-input" bind:value={column.label} placeholder="Rótulo da coluna" />
            <select class="column-type-select" bind:value={column.type}>
                {#each COLUMN_TYPES as opt (opt.value)}
                    <option value={opt.value}>{opt.label}</option>
                {/each}
            </select>
            {#if data.columns.length > 1}
                <button type="button" class="column-remove" on:click={() => removeColumn(index)}>
                    <Fa icon={faXmark} size="xs" />
                </button>
            {/if}
        </div>
    {/each}
    <button type="button" class="add-column" on:click={addColumn}>
        <Fa icon={faPlus} size="xs" />
        <span>Adicionar coluna</span>
    </button>

    <label class="public-add-row-toggle">
        <input type="checkbox" bind:checked={data.allowPublicAddRow} />
        <span>Permitir que o link público de preenchimento adicione linhas</span>
    </label>
</div>

<style>
    .block-preview {
        max-width: 520px;
    }
    .column-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 6px;
    }
    .column-reorder {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
    }
    .reorder-btn {
        border: none;
        background: transparent;
        color: #adb5bd;
        cursor: pointer;
        padding: 0 2px;
        line-height: 1;
    }
    .reorder-btn:hover:not(:disabled) {
        color: var(--cs2-accent, #4263eb);
    }
    .reorder-btn:disabled {
        opacity: 0.3;
        cursor: not-allowed;
    }
    .column-label-input {
        flex: 1;
        border: none;
        border-bottom: 1px solid transparent;
        background: transparent;
        font-size: 0.9rem;
        padding: 2px 0;
    }
    .column-label-input:focus {
        outline: none;
        border-bottom-color: var(--cs2-accent, #4263eb);
    }
    .column-type-select {
        flex-shrink: 0;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        padding: 4px 6px;
        font-size: 0.82rem;
        color: #495057;
    }
    .column-remove {
        border: none;
        background: transparent;
        color: #adb5bd;
        cursor: pointer;
        padding: 2px;
    }
    .column-remove:hover {
        color: #fa5252;
    }
    .add-column {
        display: flex;
        align-items: center;
        gap: 6px;
        border: none;
        background: transparent;
        color: #868e96;
        font-size: 0.85rem;
        padding: 4px 0;
        cursor: pointer;
    }
    .add-column:hover {
        color: var(--cs2-accent, #4263eb);
    }
    .public-add-row-toggle {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid #f1f3f5;
        font-size: 0.8rem;
        color: #495057;
        cursor: pointer;
    }
    .public-add-row-toggle input {
        width: 14px;
        height: 14px;
        accent-color: var(--cs2-accent, #4263eb);
    }
</style>
